import { type TFunction } from "i18next";

import { EMPTY_VALUE } from "../constants";
import { formatAuditDateTime, getFullName } from "../utils";
import { type UserSummary } from "../../../types";

interface AuditCellProps {
  dateTime?: string | null;
  t: TFunction;
  user?: UserSummary | null;
}

const AuditCell = ({ dateTime, t, user }: AuditCellProps) => {
  const formattedDateTime = formatAuditDateTime(dateTime);

  if (formattedDateTime === EMPTY_VALUE) {
    return <span className="text-neutral-alpha-300">{EMPTY_VALUE}</span>;
  }

  return (
    <div className="min-w-0 leading-tight">
      <div className="text-foreground">{formattedDateTime}</div>
      <div className="mt-1 truncate text-muted-foreground text-xs">
        {t("configuration.byFullName", { fullName: getFullName(user) })}
      </div>
    </div>
  );
};

export { AuditCell };
